import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, resolveComponent as _resolveComponent, createVNode as _createVNode, renderSlot as _renderSlot, createElementVNode as _createElementVNode, resolveDirective as _resolveDirective, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock, withDirectives as _withDirectives, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-5fda3531"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "text" }

import { computed } from "vue";
import { Code } from "./AppStatus";

/** icons for status codes */
interface Props {
  /** status code */
  code: Code;
  /** link */
  link?: string;
}


export default /*#__PURE__*/_defineComponent({
  __name: 'AppStatus',
  props: {
    code: null,
    link: null
  },
  setup(__props: any) {

const props = __props as {
  /** status code */
  code: Code;
  /** link */
  link?: string;
}

const icons: Record<Code, string> = {
  loading: "loading",
  paused: "pause-circle",
  success: "check-circle",
  warning: "exclamation-circle",
  error: "times-circle",
  unknown: "question-circle",
};



/** icon to show, associated with a status */
const icon = computed(() => icons[props.code]);

return (_ctx: any,_cache: any) => {
  const _component_AppIcon = _resolveComponent("AppIcon")!
  const _component_AppLink = _resolveComponent("AppLink")!
  const _directive_tooltip = _resolveDirective("tooltip")!

  return _withDirectives((_openBlock(), _createBlock(_component_AppLink, {
    to: __props.link || '',
    class: "status",
    "data-code": __props.code || '',
    "aria-label": __props.code || ''
  }, {
    default: _withCtx(() => [
      _createVNode(_component_AppIcon, {
        class: "icon",
        icon: _unref(icon)
      }, null, 8, ["icon"]),
      _createElementVNode("span", _hoisted_1, [
        _renderSlot(_ctx.$slots, "default")
      ])
    ]),
    _: 3
  }, 8, ["to", "data-code", "aria-label"])), [
    [_directive_tooltip, __props.code === 'error' ? 'See dev console for more details' : '']
  ])
}
}

})